import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const track = (event, meta = null) => {
  axios.post(`${API}/track`, { event, meta }).catch(() => {});
};
